/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetGameMinecraftUserinfoRequest = { username: string };

export const GetGameMinecraftUserinfoRequest$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoRequest
> = z.object({
  username: z.string().describe("玩家的 Minecraft 游戏内名称（正版ID）。"),
});

export type GetGameMinecraftUserinfoBadGatewayDetails = {};

export const GetGameMinecraftUserinfoBadGatewayDetails$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoBadGatewayDetails
> = z.object({});

/**
 * 上游服务错误。在向 Mojang 的官方 API 请求数据时遇到了问题。这可能是他们的服务暂时中断，请稍后重试。
 */
export type GetGameMinecraftUserinfoBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftUserinfoBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftUserinfoBadGatewayResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftUserinfoBadGatewayResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetGameMinecraftUserinfoBadGatewayDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe(
    "上游服务错误。在向 Mojang 的官方 API 请求数据时遇到了问题。这可能是他们的服务暂时中断，请稍后重试。",
  );

export type GetGameMinecraftUserinfoNotFoundDetails = {};

export const GetGameMinecraftUserinfoNotFoundDetails$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoNotFoundDetails
> = z.object({});

/**
 * 玩家未找到。根据你提供的用户名，未能找到对应的 Minecraft 玩家。请检查拼写是否正确。
 */
export type GetGameMinecraftUserinfoNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftUserinfoNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftUserinfoNotFoundResponseBody$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetGameMinecraftUserinfoNotFoundDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "玩家未找到。根据你提供的用户名，未能找到对应的 Minecraft 玩家。请检查拼写是否正确。",
);

export type GetGameMinecraftUserinfoBadRequestDetails = {};

export const GetGameMinecraftUserinfoBadRequestDetails$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoBadRequestDetails
> = z.object({});

/**
 * 请求失败。请检查你是否提供了 `username` 参数。
 */
export type GetGameMinecraftUserinfoBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetGameMinecraftUserinfoBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetGameMinecraftUserinfoBadRequestResponseBody$zodSchema:
  z.ZodType<GetGameMinecraftUserinfoBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetGameMinecraftUserinfoBadRequestDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("请求失败。请检查你是否提供了 `username` 参数。");

/**
 * 查询成功！返回用户的UUID和皮肤链接。
 */
export type GetGameMinecraftUserinfoResponseBody = {
  skin_url?: string | undefined;
  username?: string | undefined;
  uuid?: string | undefined;
};

export const GetGameMinecraftUserinfoResponseBody$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoResponseBody
> = z.object({
  skin_url: z.string().optional(),
  username: z.string().optional(),
  uuid: z.string().optional(),
}).describe("查询成功！返回用户的UUID和皮肤链接。");

export type GetGameMinecraftUserinfoResponse =
  | GetGameMinecraftUserinfoResponseBody
  | GetGameMinecraftUserinfoBadRequestResponseBody
  | GetGameMinecraftUserinfoNotFoundResponseBody
  | GetGameMinecraftUserinfoBadGatewayResponseBody;

export const GetGameMinecraftUserinfoResponse$zodSchema: z.ZodType<
  GetGameMinecraftUserinfoResponse
> = z.union([
  z.lazy(() => GetGameMinecraftUserinfoResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftUserinfoBadRequestResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftUserinfoNotFoundResponseBody$zodSchema),
  z.lazy(() => GetGameMinecraftUserinfoBadGatewayResponseBody$zodSchema),
]);
